import React from 'react';
import SidebarComponent from '../components/SidebarComponent';
import AddCategoryComponent from '../components/AddCategoryComponent';
import HeaderComponent from '../components/HeaderComponent';

class AddCategoryPage extends React.Component {
    render() {
        return (
            <div className="wrapper">
                <SidebarComponent location={this.props.location}/>
                <HeaderComponent/>
                <AddCategoryComponent />
            </div>
        );
    }
}

export default AddCategoryPage;